import React from "react";

const ScrolToTop = () => {
    return (
        <button aria-label="Interactive action" className="scroltop"><span className="fa fa-angle-up  relative" id="btn-vibrate" /></button>
    );
};

export default ScrolToTop;
